module.exports = __webpack_public_path__ + "static/full02-4c273403b4dc827347549d920e56c94b.png";